import { useEffect, useState } from "react";
import api from "../api";
import { PlayCircle, ArrowRight } from "lucide-react";
import LazyVimeo from "./LazyVimeo";

function getEmbedUrl(tip) {
  if (tip?.vimeo_url) {
    if (tip.vimeo_url.includes("player.vimeo.com")) return tip.vimeo_url;
    const m = tip.vimeo_url.match(/vimeo\.com\/(\d+)/);
    if (m) return `https://player.vimeo.com/video/${m[1]}?title=0&byline=0&portrait=0`;
    return tip.vimeo_url;
  }
  if (tip?.youtube_url) {
    const m = tip.youtube_url.match(/(?:youtu\.be\/|v=)([\w-]{11})/);
    if (m) return `https://www.youtube.com/embed/${m[1]}`;
    return tip.youtube_url;
  }
  return null;
}

export default function TipOfWeekSection() {
  const [tip, setTip] = useState(null);
  useEffect(() => {
    api.get("/tips/current").then(({ data }) => setTip(data)).catch(() => {});
  }, []);

  if (!tip) return null;
  const embed = getEmbedUrl(tip);
  if (!embed) return null;

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 pb-24" data-testid="tip-of-week-section">
      <div className="rounded-3xl overflow-hidden bg-[#1A2F25] text-[#F9F6F0] grid lg:grid-cols-12">
        <div className="lg:col-span-5 p-10 md:p-14 flex flex-col justify-center">
          <div className="flex items-center gap-2 mb-4">
            <PlayCircle className="w-5 h-5 text-[#D47C59]" strokeWidth={1.5} />
            <span className="overline text-[#D47C59]">{tip.week_label || "This week"} · Linda's Tip</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-light leading-tight mb-4">
            {tip.title}
          </h2>
          {tip.description && (
            <p className="text-[#E5E0D8] font-light leading-relaxed mb-6">
              {tip.description}
            </p>
          )}
          <p className="text-xs text-[#E5E0D8]/70 font-light">
            New tip every week — keep growing alongside Linda. <ArrowRight className="w-3 h-3 inline" />
          </p>
        </div>
        <div className="lg:col-span-7 relative bg-black">
          <LazyVimeo src={embed} title={tip.title} />
        </div>
      </div>
    </section>
  );
}
